import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


export const IconBatteryColoured = ({value}) => {
    const getIcon = (value) => {
        switch (true) {
            case value >= 20:
                return <FontAwesomeIcon icon="battery-three-quarters" className="text-success fa-rotate-270"/>
            case value >= 10:
                return <FontAwesomeIcon icon="battery-quarter" className="text-warning fa-rotate-270"/>
            default:
                return <FontAwesomeIcon icon="battery-empty" className="text-danger fa-rotate-270"/>
        }
    }

    return (
        <>
            <span className="me-2">{value}%</span>{getIcon(value)}
        </>
    )
}
export const IconTemperatureColoured = ({value}) => {
    const getIcon = (value) => {
        switch (true) {
            case value > 75:
                return <FontAwesomeIcon icon="fire" className="text-danger"/>
            case value >= 60:
                return <FontAwesomeIcon icon="temperature-full" className="text-danger"/>
            case value >= 40:
                return <FontAwesomeIcon icon="temperature-half" className="text-warning"/>
            case value > 0:
                return <FontAwesomeIcon icon="temperature-quarter" className="text-success"/>
            default:
                return <FontAwesomeIcon icon="temperature-empty" className="text-blue"/>
        }
    }
    return (
        <>
            <span className="me-2">{value}ºC</span>{getIcon(value)}
        </>
    )
}

export const IconFillingColoured = ({value}) => {
    const getIcon = (value) => {
        switch (true) {
            case value >= 80:
                return <FontAwesomeIcon icon="chart-line" className="text-danger"/>
            case value >= 50:
                return <FontAwesomeIcon icon="chart-line" className="text-warning"/>
            default:
                return <FontAwesomeIcon icon="chart-line" className="text-success"/>
        }
    }

    return (
        <>
            <span className="me-2">{value}%</span>{getIcon(value)}
        </>
    )
}